import { g as l } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as o, openBlock as d, normalizeClass as r, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconConnectionApi",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], p = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.709 10.416a.5.5 0 0 1 0-.707L5.23 8.188 4.062 7.02l-1.52 1.52a.5.5 0 1 1-.707-.707l1.521-1.521-.584-.584a.5.5 0 0 1 0-.708l1.562-1.56a2.268 2.268 0 0 1 3.207 0l.271.271 1.21-1.209a.5.5 0 1 1 .707.708l-1.21 1.209.272.271a2.268 2.268 0 0 1 0 3.207L7.229 9.48a.5.5 0 0 1-.708 0l-.583-.584-1.522 1.521a.5.5 0 0 1-.707 0Zm3.125-6.25a1.268 1.268 0 0 0-1.793 0L3.832 5.375l3.043 3.043 1.209-1.209a1.268 1.268 0 0 0 0-1.793l-1.25-1.25Z",
  fill: "currentColor"
}, null, -1), h = [
  p
], f = ["id"], m = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  m
];
function I(e, v, n, b, q, t) {
  return d(), o("svg", {
    "aria-label": n.ariaLabel,
    class: r([t.iconSizeClass, "d-icon d-icon--connection-api"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Connection Api",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, h, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, f)
    ])
  ], 10, _);
}
const w = /* @__PURE__ */ s(c, [["render", I]]);
export {
  w as default
};
//# sourceMappingURL=connection-api.js.map
